import React from 'react'
// import { Loader } from 'rsuite'
import {
  DescriptionTitle, FlexH, FlexV, StepsContainer,
  CompletedText, onCompletedStyles
} from '../Event/EventStyledComponents'
import { VideoFrame, PhotoFrame } from '../Activity/ActivityStyledComponents'
import BriefDescriptionList from '../Event/BriefDescriptionList'
import FullDescription from '../Event/FullDescription'
import { EventIsCompletedIcon, EventIsAlmostCompleted } from '../Icons'
import styled from 'styled-components'
import { colors } from '../Styles/common-styles'

const Background = styled.div`
    height: 100%;
    color: ${colors.purpleMain}
`

const Message = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 560px;
    height: 506px;
    background: ${colors.white};
    border-radius: 8px;
`

const MessageTitle = styled.div`
    font-size: 64px;
    font-weight: 600;
    line-height: 183px;
    letter-spacing: 4px;
    color: ${colors.grey}
`

const MessageText = styled.div`
    font-size: 32px;
    font-weight: 400;
    line-height: 46px;
    letter-spacing: 0px;
    color: ${colors.black}
`
const getVideoId = activity => {
  const url = activity?.video.embed_url || null
  if (url) {
    let id = url?.split('v=')[1]
    const ampersandPosition = id.indexOf('&')
    ampersandPosition !== -1 ?? (id = id.substring(0, ampersandPosition))
    return id
  } else return null
}

const Overview = (props) => {
  const {
    isEventFinished, currentActivity,
    currentPhase, event
  } = props

  const phase = event?.phases[currentPhase]
  const activity = phase?.data[currentActivity]

  const title = activity?.title[0].text
  const videoId = getVideoId(activity)
  const image = activity?.cover_image.thumbnail.url || null

  const isEventDone = event?.phases.every(phase => phase.isCompleted)
  return (
    <>
      {!activity && !isEventFinished
        ? <>
          <Background>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex' }}>
                <div className='brand-name'>
                  <span className='taito'>TAITO</span>
                  <span className='training'>TRAINING</span>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Message>
                  <MessageTitle>Please wait....</MessageTitle>
                  <MessageText>The next phase will begin shortly</MessageText>
                </Message>
              </div>
            </div>
          </Background>
        </>
        : !isEventFinished && <>
          <DescriptionTitle> {title} </DescriptionTitle>
          <StepsContainer>
            <FlexH>
              <FlexV>
                {videoId
                  ? <VideoFrame src={`https://www.youtube.com/embed/${videoId}?feature=oembed}`} />
                  : image && <PhotoFrame src={image} />}
                <BriefDescriptionList activity={activity} />
              </FlexV>

              <FlexV>
                <FullDescription
                  fullDescription={activity.description}
                  tools={activity.requisites} // tools
                  goals={activity.goals}
                  preparation={activity.preparation}
                />
              </FlexV>
            </FlexH>
          </StepsContainer>
        </>}
      {isEventFinished &&
        <>
          {isEventDone
            ? <>
              <div style={onCompletedStyles.flexColumn}>
                <div style={onCompletedStyles.image}> <EventIsCompletedIcon /> </div>
                <span style={onCompletedStyles.title}>That's all, well done!</span>
                <span style={onCompletedStyles.span}>
                  The event is completed. You can go back to your other events or review this one by phases and activities.
                </span>
              </div>
              <FlexH style={onCompletedStyles.flexRow}>
                <CompletedText>&#10003; COMPLETED</CompletedText>
              </FlexH>
            </>
            : <>
              <div style={onCompletedStyles.flexColumn}>
                <div style={onCompletedStyles.image}> <EventIsAlmostCompleted /> </div>
                <span style={onCompletedStyles.title}>You almost missed it...</span>
                <span style={onCompletedStyles.span}>
                  There is one or few activities you left uncompleted. Get back to them or skip and go to your other events.
                </span>
              </div>
            </>}
        </>}
    </>
  )
}

export default Overview
